// Production: the Flask backend is proxied by nginx under the same origin
// at /api/, so a same-origin relative base works with no env config.
// Local dev: override via frontend/.env.development (REACT_APP_BASE_URL).
export const BASE_URL = process.env.REACT_APP_BASE_URL || "/api/";

export const endPoints: {
  [key in "contact"]: string;
} = {
  contact: "contact/",
};
